import React from "react";
import { ShopContext } from "../../Context";
import image_service_null from '../../assets/image_service_null.png';
import image_product_empty from '../../assets/image_product_empty.svg';
import './Product.css';

export const Product=({id,name,price,image})=>{   
  const{  
    formatCurrency,
    openProductDetail,
    setProductToShow,   
    setOpenModal  
  }=React.useContext(ShopContext)  
  
  const showProduct=(ProductDeatail)=>{
   setOpenModal(true); 
   openProductDetail();
   setProductToShow(ProductDeatail);
}
   return(    

           <figure className="container-service"  >  
                <div id={id} className="container-service-img" 
                     style={{       
                              backgroundImage:image==='public/assets/pictures/'?'url('+image_product_empty+')':'url(https://admin.servidev.com/'+image,
                              gridArea:'service'+id                    
                            }} >
                </div> 
                <figcaption className="container-service-detail">
                <h3 >{name}</h3>
                <h3>${formatCurrency(price)}</h3>                  
                        <button onClick={()=>{                       
                            showProduct({
                                        id:id,
                                        descripcion:name,
                                        precio:price,
                                        imagen:image
                                        });
                            }
                            }>Comprar</button>
                </figcaption>
            </figure>
   );
}